// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const PaymentRequestButtonElementDemo: MarkdocTagRegistration = {
  tag: 'payment-request-button-element-demo',
  component: 'PaymentRequestButtonElementDemo',
};
